import { api } from '@/v2/plugins/axios';

const API_PATH = '/salla';

export class SallaMarketplace {
	static getBrands(params = {}) {
		return api.get(`${API_PATH}/brand`, { params }).then((res) => {
			const brands = res.data?.result?.brands;
			const totalRecords = brands.total;
			const data = brands.data;

			return {
				data,
				totalRecords,
			};
		});
	}

	static getCategories(params = {}) {
		return api.get(`${API_PATH}/category`, { params }).then((res) => {
			const categories = res.data?.result?.categories;
			const totalRecords = categories.total;
			const data = categories.data;

			return {
				data,
				totalRecords,
			};
		});
	}

	static getCategoryAttributes(categoryID) {
		return api.get(`${API_PATH}/category/${categoryID}/category-attributes`).then((res) => {
			const categoryAttribute = res.data?.result?.categoryAttribute;
			const data = categoryAttribute;

			return {
				data,
			};
		});
	}

	static getAttributeValues(params, categoryID, marketplaceAttributeID) {
		return api
			.get(`${API_PATH}/category/${categoryID}/attribute/${marketplaceAttributeID}`, { params })
			.then((res) => {
				const attributeValues = res.data?.result?.attributeValues;
				const totalRecords = attributeValues.total;
				const data = attributeValues.data;

				return {
					data,
					totalRecords,
				};
			});
	}
}
